import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {
    Statistic,
    Icon,
    Breadcrumb,
    Header,
    Divider,
    List,
    Container,
    Form,
    Select,
    Image,
    Grid,
    Button
} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import {FormattedNumber} from 'react-intl';
import moment from 'moment';

import CustomDivider from '../../components/extras/CustomDivider';
import AlertUpgrade from '../../components/extras/AlertUpgrade';
import LineChartCurrency from '../../components/charts/LineChartCurrency';
import SaleData from "../../data/SaleData";
import BranchOfficeData from "../../data/BranchOfficeData";
import {connect} from "react-redux";
import HorizontalAds from "../../components/ads/HorizontalAds";
import localDB from "../../data/localDB";

class Home extends Component {
    constructor() {
        super();
        this.state = {
            sales: {
                total_day: 0,
                count_products: 0,
                expenses: 0,
                total_people: 0,
                number_sales: 0
            },
            products: [],
            branch_offices: [],
            graphics_day: {total_sales: 0, data: []},
            branch_office: {
                id: '',
                name: ''
            },
            btn_day: true,
            btn_week: false,
            btn_month: false,
            date: moment().format('MM/DD/YYYY'),
            loading: true
        };
        this.handleBranchOfficeChange = this.handleBranchOfficeChange.bind(this);
        this.dataDay = this.dataDay.bind(this);
        this.dataWeek = this.dataWeek.bind(this);
        this.dataMonth = this.dataMonth.bind(this);
        this.initialFetch = this.initialFetch.bind(this);
    }

    async componentDidMount() {
        await this.getBranchOffices();
    }

    handleBranchOfficeChange = async (result) => {
        this.setState({branch_office: {id: result, name: result}});
        await this.initialFetch(result);
    };

    async initialFetch(branch_office) {
        await SaleData.getDay(branch_office).then(res =>{
            this.setState({
                sales: res.sales,
                products: res.products,
                btn_day: true,
                btn_week: false,
                btn_month: false,
                loading: false
            });
            if (this.refs.sales_chart && this.refs.expenses_chart){
                this.refs.sales_chart.loadData(branch_office, 'd', moment().format('MM/DD/YYYY'));
                this.refs.expenses_chart.loadData(branch_office, 'd', moment().format('MM/DD/YYYY'));
            }
        });
    };

    async getBranchOffices() {
        await BranchOfficeData.listAll().then(async branch_offices =>{
            this.setState({branch_offices});
            await this.handleBranchOfficeChange(branch_offices[0].key)
        });
    };

    dataDay() {
        this.setState({btn_day: true, btn_week: false, btn_month: false});
        this.refs.sales_chart.loadData(this.state.branch_office.id, 'd', this.state.date);
        this.refs.expenses_chart.loadData(this.state.branch_office.id, 'd', this.state.date);
    };

    dataWeek() {
        if (!localDB.checkPlanAccessExclude('reports_view_all')) {
            this.setState({btn_day: false, btn_week: true, btn_month: false});
            this.refs.sales_chart.loadData(this.state.branch_office.id, 'w', this.state.date);
            this.refs.expenses_chart.loadData(this.state.branch_office.id, 'w', this.state.date);
        } else {
            this.refs.alert_upgrade.open();
        }
    };


    dataMonth() {
        if (!localDB.checkPlanAccessExclude('reports_view_all')) {
            this.setState({btn_day: false, btn_week: false, btn_month: true});
            this.refs.sales_chart.loadData(this.state.branch_office.id, 'm', this.state.date);
            this.refs.expenses_chart.loadData(this.state.branch_office.id, 'm', this.state.date);
        } else {
            this.refs.alert_upgrade.open();
        }
    };

    render() {
        let products = this.state.products.length > 0 ? this.state.products.map(function (product) {
                return (
                    <List.Item key={product.product}>
                        <List.Content>
                            <Image avatar src={`${product.picture}?tr=w-200,ar-4-4`} alt={product.product__name}/>
                            <List.Header>{product.product__name}</List.Header>
                            <b>{product.total} </b>unidades vendidas
                        </List.Content>
                    </List.Item>
                )
            }, this) :
            <List.Item key={1}>
                <List.Content>
                    <List.Icon name='frown outline' size='big' verticalAlign='middle'/>
                    <List.Header>Aún no se han realizado ventas!</List.Header>
                </List.Content>
            </List.Item>
        ;

        return (
            <div>
                <Helmet>
                    <title>Quipuu - Inicio</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Inicio</Breadcrumb.Section>
                </Breadcrumb>
                {this.state.visible ?
                    <p style={{float: 'right'}}>
                        <a href={`https://quipuu.com/restaurants/${this.state.store.slug}`} target='_blank'
                           rel="noopener noreferrer"><Icon name='food'/> Ir a {this.state.store.name}</a>
                    </p> : null
                }
                <CustomDivider/>
                <Grid columns={1}>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Form>
                                <Form.Field inline>
                                    <label>Sucursal:</label>
                                    <Select options={this.state.branch_offices}
                                            onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                            value={this.state.branch_office.id} placeholder='Sucursal'
                                            error={this.state.branch_office_error} width={4}/>
                                </Form.Field>
                            </Form>
                            <Header as='h2' icon textAlign='center' dividing>
                                <Icon name='clock outline'/>
                                <Header.Content>
                                    En el día de hoy
                                </Header.Content>
                            </Header>
                            <Statistic.Group widths={2}>
                                <Statistic>
                                    <Statistic.Value>
                                        $<FormattedNumber value={this.state.sales.total_day} currency="USD"
                                                          maximumFractionDigits={0} minimumFractionDigits={0}/>
                                    </Statistic.Value>
                                    <Statistic.Label>En Caja</Statistic.Label>
                                </Statistic>
                                <Statistic>
                                    <Statistic.Value>
                                        $<FormattedNumber value={this.state.sales.expenses} currency="USD"
                                                          maximumFractionDigits={0}
                                                          minimumFractionDigits={0}/>
                                    </Statistic.Value>
                                    <Statistic.Label>En Gastos</Statistic.Label>
                                </Statistic>
                            </Statistic.Group>
                            <Divider/>
                            <Statistic.Group widths={3}>
                                <Statistic>
                                    <Statistic.Value>
                                        <Icon name='shopping basket'/> {this.state.sales.number_sales}
                                    </Statistic.Value>
                                    <Statistic.Label>Ventas Realizadas</Statistic.Label>
                                </Statistic>
                                <Statistic>
                                    <Statistic.Value>
                                        <Icon name='shopping cart'/> {this.state.sales.count_products}
                                    </Statistic.Value>
                                    <Statistic.Label>Productos Vendidos</Statistic.Label>
                                </Statistic>
                                <Statistic>
                                    <Statistic.Value>
                                        <Icon name='users'/> {this.state.sales.total_people}
                                    </Statistic.Value>
                                    <Statistic.Label>Personas</Statistic.Label>
                                </Statistic>
                            </Statistic.Group>
                            <Divider/>
                            <Container textAlign='center'>
                                <Header as='h3' icon textAlign='center'>
                                    <Header.Content>
                                        Lo más vendido
                                    </Header.Content>
                                </Header>
                                <List horizontal size='huge' divided>
                                    {products}
                                </List>
                            </Container>
                            {localDB.get('rol_access').includes('home_sales_history') ? <React.Fragment>
                                <Divider/>
                                <br/>
                                <Button.Group style={{marginBottom: 20}}>
                                    <Button primary={this.state.btn_day} onClick={this.dataDay}>Hoy</Button>
                                    <Button.Or text='o'/>
                                    <Button primary={this.state.btn_week} onClick={this.dataWeek}>Esta Semana</Button>
                                    <Button.Or text='o'/>
                                    <Button primary={this.state.btn_month} onClick={this.dataMonth}>Este Mes</Button>
                                </Button.Group>
                                <Grid stackable textAlign='center'>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            id='sales_chart'
                                            title='Ingresos'
                                            ref='sales_chart'
                                            type='sales'
                                            demo={true}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Gastos'
                                            id='expenses_chart'
                                            ref='expenses_chart'
                                            type='expenses'
                                            demo={true}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                {localDB.checkRolAccess('reports_view_all') ?
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <Button primary as={Link} to='/reports' icon='bar chart' labelPosition='left'
                                                    content='Ver Otros Informes'/>
                                        </Grid.Column>
                                    </Grid.Row> : null
                                }
                            </Grid>
                            </React.Fragment>:null}
                        </Grid.Column>
                    </Grid.Row>
                    <HorizontalAds/>
                    <AlertUpgrade ref='alert_upgrade'/>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        suscription: state.get('suscription'),
    };
};

export default connect(
    mapStateToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/Home.js